import React from 'react';
import cn from 'classnames';
import styles from './index.module.scss';

import Modal from '../Modal';

export default function SheetBody({ className = '', children = null }) {
  return (
    <Modal.Body className={cn(styles.body, className)}>{children}</Modal.Body>
  );
}
